export default __webpack_public_path__ + "static/media/ot-timekeeping.877e0f9a.svg";